import CONSTANTS from "../CONSTANTS";

const initialState = {
  is_creating_kits: false
};

const managementUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.KITS_SET_LOCAL_STATE:
      return { ...state, is_creating_kits: action.status };
    default:
      return state;
  }
};

export default managementUserReducer;
